export default __webpack_public_path__ + "98c5c93870ac8eb2051721302bc34bca.svg";